import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const CheckboxMeta: ComponentMeta = {
  componentName: "Checkbox",
  package: "@mijadesign/web",
  title: "复选框",
  description: "复选框，用于勾选或取消勾选",
  category: ComponentCategory.FORM,
  icon: "CheckSquareOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "checked",
      label: "是否选中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "value",
      label: "值",
      type: PropType.STRING,
      group: "数据",
    },
    {
      name: "children",
      label: "文本",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "indeterminate",
      label: "半选状态",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    checked: false,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Checkbox",
  },
  snippet: {
    componentName: "Checkbox",
    package: "@mijadesign/web",
    props: { children: "复选框" },
  },
};

export const CheckboxGroupMeta: ComponentMeta = {
  componentName: "Checkbox.Group",
  package: "@mijadesign/web",
  title: "复选组",
  description: "复选框组，用于多选",
  category: ComponentCategory.FORM,
  icon: "CheckSquareOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "value",
      label: "选中值",
      type: PropType.ARRAY,
      group: "数据",
    },
    {
      name: "options",
      label: "选项",
      type: PropType.JSON,
      description: '选项列表，如：[{ label: "选项1", value: "1" }]',
      group: "数据",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "max",
      label: "最大可选数",
      type: PropType.NUMBER,
      group: "限制",
    },
  ],
  defaultProps: {
    options: [
      { label: "选项1", value: "1" },
      { label: "选项2", value: "2" },
      { label: "选项3", value: "3" },
    ],
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Checkbox",
  },
  snippet: {
    componentName: "Checkbox.Group",
    package: "@mijadesign/web",
    props: {
      options: [
        { label: "选项1", value: "1" },
        { label: "选项2", value: "2" },
      ],
    },
  },
};
